import { useDispatch } from "react-redux";

import { handBookActions } from "pages/HandBook/model/slice";
import { IHandBook } from "pages/HandBook/model/types";
import { IHandbookColumn } from "pages/HandBook/widgets/HandBookList/HandBookList";

import HandbookAddForm from "../HandbookAddForm/HandbookAddForm";
import HandbookForm, { IHandbookFormField } from "../HandbookForm/HandbookForm";
import { useTypedSelector } from "app/store/typedUseSelector";
import TableReusableRow, { TableReusableCell } from "shared/ui/dataDisplay/TableReusable/TableReusableRow";
import Checkbox from "shared/ui/inputs/Checkbox/Checkbox";
import RowGrid, { ROW_GRID_UNIT } from "shared/ui/layout/RowGrid/RowGrid";

import styles from "./HandbookRow.module.scss";

interface IProps {
  colPercents: number[];
  columns: IHandbookColumn[];
  item: IHandBook;
  formColPercents?: number[];
  fields: IHandbookFormField[];
  canCheck?: boolean;
}

const HandbookRow = ({ colPercents, columns, item, formColPercents, fields, canCheck }: IProps) => {
  const dispatch = useDispatch();
  const isEditing = useTypedSelector((state) => state.handBookReducer.editings.isEditing);
  const editings = useTypedSelector((state) => state.handBookReducer.editings);
  // @ts-ignore
  if (item._new) {
    if (isEditing) return null;
    return <HandbookAddForm item={item} colPercents={formColPercents ?? colPercents} fields={fields} />;
  }
  if (isEditing) {
    return <HandbookForm item={item} colPercents={formColPercents ?? colPercents} fields={fields} />;
  }

  const onCheckItem = () => {
    dispatch(handBookActions.localCheckItem({ id: item.id, isChecked: !Boolean(editings.checked[item.id]) }));
  };

  const displayColPrecents = canCheck ? [5, Math.max(0, colPercents[0] - 5), ...colPercents.slice(1)] : colPercents;

  return (
    <TableReusableRow isHoverable={false} className={styles.row} containerClassName={styles.container}>
      <RowGrid percents={displayColPrecents} unit={ROW_GRID_UNIT.PERCENT}>
        {canCheck && <Checkbox onCheck={onCheckItem} checked={editings.checked[item.id]} className={styles.checkbox} noMargin />}
        {columns.map((el) =>
          el.render ? (
            <TableReusableCell
              isCentered={el.isCentered}
              isNoBreak={el.isNoBreak}
              isRighted={el.isRighted}
              key={el.header.title}
            >
              {el.render(item)}
            </TableReusableCell>
          ) : null
        )}
      </RowGrid>
    </TableReusableRow>
  );
};

export default HandbookRow;
